import dayjs from 'dayjs';
import isBetween from "dayjs/plugin/isBetween"

import { useCallback } from 'react';
import { useFilterFormContext } from '../context';
import { useIntl } from 'react-intl';

import { NAVIGATION_HISTORY_SEARCH_WIDTH } from 'entities/navigation';

dayjs.extend(isBetween);

export const useValidateFilterForm = () => {
  const { formatMessage } = useIntl();
  const { autoObuNumber, startDate, endDate } = useFilterFormContext();

  const validateFilterForm = useCallback(() => {
    return {
      ...!Object.keys(autoObuNumber).length && {
        autoObuNumber: formatMessage({ id: 'error.fieldCannotBeEmpty' }),
      },
      ...!dayjs(endDate).isBetween(startDate, dayjs(startDate).add(NAVIGATION_HISTORY_SEARCH_WIDTH, 'day')) && {
        endDate: formatMessage({ id: 'error.rangeStartAndEndDates' })
      },
      ...dayjs(startDate).isAfter(endDate) && {
        endDate: formatMessage({ id: 'error.startAndEndDates' })
      }
    };
  }, [
    formatMessage,
    autoObuNumber,
    startDate,
    endDate
  ]);

  return validateFilterForm;
};
